// extracted by mini-css-extract-plugin
module.exports = {"Favorites":"Favorites_Favorites__Er0HV","LikeImg":"Favorites_LikeImg__JSenh","FavoritesButton":"Favorites_FavoritesButton__JIKSQ"};